// extracted by mini-css-extract-plugin
export var clipPath = "SquearesBackground-module--clipPath--x3RgN";
export var figure = "SquearesBackground-module--figure--PhlEh";
export var flicker = "SquearesBackground-module--flicker--Fh0PN";
export var hidden = "SquearesBackground-module--hidden--Jz2bh";
export var shadow = "SquearesBackground-module--shadow--U9uWa";
export var square = "SquearesBackground-module--square--cy0r6";
export var staticBg = "SquearesBackground-module--staticBg--pr8cB";
export var wrapper = "SquearesBackground-module--wrapper--dvT+-";
export var wrapper__background = "SquearesBackground-module--wrapper__background--Rruu5";